import { AppDispatch, GetState, RootState } from '../store';
import { sessionService } from '../../services/session.service';
import { initSessionError, initSessionStarted, initSessionSuccess } from '../actions/session.actions';
import { startSession } from './start-session.thunk';
import { SessionConfiguration } from '../../services/interfaces/session.interface';
import { reportError } from '../slices/error.slice';
import { selectSessionState } from '../slices/session.slice';
import { Session } from '../../types/session';

export const initSession = (configuration: SessionConfiguration) => {
	return async (dispatch: AppDispatch, getState: GetState): Promise<void> => {
		const state = getState();
		if (isSessionCreated(state)) return;

		dispatch(initSessionStarted());
		try {
			const session = await initializeSession(configuration);
			const id = session.sessionId;
			dispatch(initSessionSuccess(session));
			dispatch(startSession(id));
		} catch (error: any) {
			dispatch(
				reportError({
					type: 'TECHNICAL',
					message: 'An internal technical error has occurred',
					reason: { ...error, json: JSON.stringify(error) }
				})
			);

			dispatch(initSessionError());
		}
	};
};

const isSessionCreated = (state: RootState): boolean => {
	const status = selectSessionState(state);
	return status !== 'IDLE';
};

const initializeSession = async (configuration: SessionConfiguration): Promise<Session> => {
	const currentURL: URL = new URL(window.location.href);

	if (isBankRedirect(currentURL)) {
		return sessionService.getSession();
	} else {
		return sessionService.createSession(configuration);
	}
};

const isBankRedirect = (URL: URL) => {
	return URL.searchParams.get('redirect') === 'klarna';
};
